<div class="flex-column">
	<div class="flex-row" *ngFor="let item of data" style="align-items: center; margin-top: 3px;">
		<mat-label style="margin: 0 5px; text-align: left;">{{ item.display }}</mat-label>
		<mat-progress-bar style="flex: 1; margin: 0 5px; height: 7px;" [value]="100 * (item.value / totalValue)"></mat-progress-bar>
		<mat-label style="margin: 0 5px; text-align: right;">{{ (100 * (item.value / totalValue)).toFixed(0) }}%</mat-label>
	</div>
</div>